export enum AdCampaignEventType {
  CLICK = 'CLICK',
  IMPRESSION = 'IMPRESSION',
}

export enum AuthStatus {
  Authenticated = 'AUTHENTICATED',
  NotAuthenticated = 'NOT_AUTHENTICATED',
  NotAuthorized = 'NOT_AUTHORIZED',
  Offline = 'OFFLINE',
}

export enum CurrentOrderSection {
  CallSheet = 'CALL_SHEET',
  Draft = 'DRAFT',
  Placed = 'PLACED',
}

export enum ChatStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  NEW = 'NEW',
  PROSPECT = 'PROSPECT',
}

export enum CreditRequestFormCustomPropertyType {
  DATE = 'DATE',
  TEXT = 'TEXT',
}

export enum ViewableByWithNone {
  ALL = 'ALL',
  NONE = 'NONE',
  RESTAURANT = 'RESTAURANT',
  SUPPLIER = 'SUPPLIER',
}

export enum ViewableBy {
  ALL = 'ALL',
  RESTAURANT = 'RESTAURANT',
  SUPPLIER = 'SUPPLIER',
}

export enum EmployeeStatus {
  Active = 'ACTIVE',
  Invited = 'INVITED',
  Pending = 'PENDING',
}

export enum ExternalContentURLTypes {
  HOLISTICS_DASHBOARD = 'HOLISTICS_DASHBOARD',
  STATIC_URL = 'STATIC_URL',
  TOOL = 'TOOL',
}

export enum PermissionAction {
  Read = 'READ',
  Write = 'WRITE',
}

export enum PermissionSubject {
  CallSheet = 'call_sheet',
  Commissions = 'allow_commission',
  SrtPriceEditing = 'srt_price_editing',
}

export enum PriceTrendsDisplayType {
  GP = 'GP',
  Price = 'PRICE',
}

export enum GtinMetadataFormatType {
  Supplier = 'SUPPLIER',
  Syndigo = 'SYNDIGO',
}

export enum LeadTimeSplitBehavior {
  Default = 'DEFAULT',
  EnforceOrderMinimum = 'ENFORCE_ORDER_MINIMUM',
  Thyme = 'THYME',
}

export enum ListDisplayMode {
  Grid = 'GRID',
  List = 'LIST',
}

export enum MessageType {
  INVOICE = 'INVOICE',
  MEDIA = 'MEDIA',
  ORDER = 'ORDER',
  PLAINTEXT = 'PLAINTEXT',
  SYSTEM_MESSAGE = 'SYSTEM_MESSAGE',
  UPDATE = 'UPDATE',
}

export enum OrderStatus {
  AutoOrdered = 'AUTO_ORDERED',
  Cancelled = 'CANCELLED',
  ConfirmedBySupplier = 'CONFIRMED_BY_SUPPLIER',
  Delivered = 'DELIVERED',
  Draft = 'DRAFT',
  InExternalReview = 'IN_EXTERNAL_REVIEW',
  InReview = 'IN_REVIEW',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  Rated = 'RATED',
  ReceivedBySupplier = 'RECEIVED_BY_SUPPLIER',
  SentToSupplier = 'SENT_TO_SUPPLIER',
  ShouldBeDelivered = 'SHOULD_BE_DELIVERED',
  Undelivered = 'UNDELIVERED',
  ViewedBySupplier = 'VIEWED_BY_SUPPLIER',
}

export enum OrderGuideErrorCode {
  // Request references order guide entities that no longer exist
  STALE = 'ORDER_GUIDE_STALE',
}

export enum OrderValidationErrorCode {
  ORDER_ALREADY_PLACED = 'ORDER_ALREADY_PLACED',
  ORDER_FAILED_PAYMENT = 'ORDER_FAILED_PAYMENT',
  ORDER_VALIDATOR_ERROR = 'ORDER_VALIDATOR_ERROR',
}

export enum PromotionErrorCode {
  MISSING_DISCOUNT_CODES = 'MISSING_DISCOUNT_CODES',
}

export enum PackUnit {
  Bag = 'BAG',
  Bale = 'BALE',
  Barrel = 'BARREL',
  Basket = 'BASKET',
  Bch = 'BCH',
  Bin = 'BIN',
  BIN_OF_36 = 'BIN_OF_36',
  BIN_OF_45 = 'BIN_OF_45',
  BIN_OF_60 = 'BIN_OF_60',
  Block = 'BLOCK',
  BoardFoot = 'BOARD_FOOT',
  Bottle = 'BOTTLE',
  Bouquet = 'BOUQUET',
  Box = 'BOX',
  Braid = 'BRAID',
  Break = 'BREAK',
  Bucket = 'BUCKET',
  Bulk = 'BULK',
  Bunch = 'BUNCH',
  Bundle = 'BUNDLE',
  Bushel = 'BUSHEL',
  Can = 'CAN',
  Canister = 'CANISTER',
  Card = 'CARD',
  Carton = 'CARTON',
  Case = 'CASE',
  Centimeter = 'CENTIMETER',
  ClamshellBox = 'CLAMSHELL_BOX',
  Container = 'CONTAINER',
  Count = 'COUNT',
  Crate = 'CRATE',
  Cube = 'CUBE',
  CubicCentimeter = 'CUBIC_CENTIMETER',
  CubicFoot = 'CUBIC_FOOT',
  CubicYard = 'CUBIC_YARD',
  Cup = 'CUP',
  Curie = 'CURIE',
  Cylinder = 'CYLINDER',
  Day = 'DAY',
  Deal = 'DEAL',
  Dewar = 'DEWAR',
  Diameter = 'DIAMETER',
  Dispenser = 'DISPENSER',
  Display = 'DISPLAY',
  Dozen = 'DOZEN',
  Drum = 'DRUM',
  Each = 'EACH',
  EightEachPack = '_8_EACH_PACK',
  EighthWheel = 'EIGHTH_WHEEL',
  Fish = 'FISH',
  FiveGallon = '_5_GALLON',
  FivePoundSplit = 'FIVE_POUND_SPLIT',
  Flat = 'FLAT',
  Foot = 'FOOT',
  FourEachPack = '_4_EACH_PACK',
  Gallon = 'GALLON',
  Grain = 'GRAIN',
  Gram = 'GRAM',
  Gross = 'GROSS',
  HalfBox = 'HALF_BOX',
  HalfBushel = 'HALF_BUSHEL',
  HalfCase = 'HALF_CASE',
  HalfDozen = 'HALF_DOZEN',
  HalfFlat = 'HALF_FLAT',
  HalfGallon = 'HALF_GALLON',
  HalfPound = 'HALF_POUND',
  HalfWheel = 'HALF_WHEEL',
  Hamper = 'HAMPER',
  Head = 'HEAD',
  Hour = 'HOUR',
  Hundred = 'HUNDRED',
  HundredWeight = 'HUNDRED_WEIGHT',
  Inch = 'INCH',
  Individual = 'INDIVIDUAL',
  Inner = 'INNER',
  Jar = 'JAR',
  Jerry = 'JERRY',
  Jug = 'JUG',
  Keg = 'KEG',
  Kg = 'KG',
  Kilogram = 'KILOGRAM',
  Kit = 'KIT',
  Label = 'LABEL',
  Lambda = 'LAMBDA',
  Layer = 'LAYER',
  Lb = 'LB',
  Length = 'LENGTH',
  LinearFoot = 'LINEAR_FOOT',
  LinearYard = 'LINEAR_YARD',
  Liter = 'LITER',
  Loaf = 'LOAF',
  Loin = 'LOIN',
  Lot = 'LOT',
  Lug = 'LUG',
  MasterCase = 'MASTER_CASE',
  MasterPack = 'MASTER_PACK',
  Meter = 'METER',
  Micron = 'MICRON',
  Milligram = 'MILLIGRAM',
  Milliliter = 'MILLILITER',
  Millimeter = 'MILLIMETER',
  Minute = 'MINUTE',
  Month = 'MONTH',
  Number_6Can = 'NUMBER_6_CAN',
  Number_10Can = 'NUMBER_10_CAN',
  Omega = 'OMEGA',
  Ounce = 'OUNCE',
  Outer = 'OUTER',
  Pack = 'PACK',
  Package = 'PACKAGE',
  Packet = 'PACKET',
  Page = 'PAGE',
  Pail = 'PAIL',
  Pair = 'PAIR',
  Pallet = 'PALLET',
  Pc1 = 'PC1',
  Pc5 = 'PC5',
  Peck = 'PECK',
  Piece = 'PIECE',
  Pint = 'PINT',
  Portion = 'PORTION',
  Pouch = 'POUCH',
  Pound = 'POUND',
  PoundSplit = 'POUND_SPLIT',
  Quart = 'QUART',
  Quarter = 'QUARTER',
  QuarterBox = 'QUARTER_BOX',
  QuarterWheel = 'QUARTER_WHEEL',
  Rack = 'RACK',
  Ream = 'REAM',
  Rod = 'ROD',
  Roll = 'ROLL',
  Sack = 'SACK',
  Segment = 'SEGMENT',
  Set = 'SET',
  Sheet = 'SHEET',
  Side = 'SIDE',
  SixEachPack = '_6_EACH_PACK',
  Sleeve = 'SLEEVE',
  Slv = 'SLV',
  SmallBox = 'SMALL_BOX',
  Split = 'SPLIT',
  Spool = 'SPOOL',
  SquareFoot = 'SQUARE_FOOT',
  SquareYard = 'SQUARE_YARD',
  Stalk = 'STALK',
  Stem = 'STEM',
  Tag = 'TAG',
  Tail = 'TAIL',
  Thousand = 'THOUSAND',
  ThreeEachPack = '_3_EACH_PACK',
  Tin = 'TIN',
  Tote = 'TOTE',
  Transaction = 'TRANSACTION',
  Tray = 'TRAY',
  Tub = 'TUB',
  Tube = 'TUBE',
  TwoEachPack = '_2_EACH_PACK',
  TwoGallon = '_2_GALLON',
  TwoPoundSplit = '_2_POUND_SPLIT',
  Unit = 'UNIT',
  Vial = 'VIAL',
  Wedge = 'WEDGE',
  Week = 'WEEK',
  WetPack = 'WET_PACK',
  Wheel = 'WHEEL',
  Whole = 'WHOLE',
  Wing = 'WING',
  Yard = 'YARD',
  Year = 'YEAR',
}

export enum PaymentBatchLineItemName {
  REFUND = 'REFUND',
  TRANSACTION_FEE = 'TRANSACTION_FEE',
}

export enum PaymentBatchLineItemType {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT',
}

export enum PaymentBatchResultCode {
  AUTHENTICATIONFINISHED = 'AUTHENTICATIONFINISHED',
  AUTHENTICATIONNOTREQUIRED = 'AUTHENTICATIONNOTREQUIRED',
  AUTHORISED = 'AUTHORISED',
  CANCELLED = 'CANCELLED',
  CHALLENGESHOPPER = 'CHALLENGESHOPPER',
  ERROR = 'ERROR',
  IDENTIFYSHOPPER = 'IDENTIFYSHOPPER',
  PENDING = 'PENDING',
  PRESENTTOSHOPPER = 'PRESENTTOSHOPPER',
  RECEIVED = 'RECEIVED',
  REDIRECTSHOPPER = 'REDIRECTSHOPPER',
  REFUSED = 'REFUSED',
}

export enum PaymentBatchStatus {
  AUTHORISATION = 'AUTHORISATION',
  AUTHORISATION_ADJUSTMENT = 'AUTHORISATION_ADJUSTMENT',
  AUTHORISATION_ADJUSTMENT_FAILED = 'AUTHORISATION_ADJUSTMENT_FAILED',
  AUTHORISATION_FAILED = 'AUTHORISATION_FAILED',
  AUTORESCUE = 'AUTORESCUE',
  CANCEL_AUTORESCUE = 'CANCEL_AUTORESCUE',
  CANCEL_OR_REFUND = 'CANCEL_OR_REFUND',
  CANCELLATION = 'CANCELLATION',
  CAPTURE = 'CAPTURE',
  CAPTURE_FAILED = 'CAPTURE_FAILED',
  CHARGEBACK = 'CHARGEBACK',
  CHARGEBACK_REVERSED = 'CHARGEBACK_REVERSED',
  CREATED = 'CREATED',
  DUPLICATE = 'DUPLICATE',
  HANDLED_EXTERNALLY = 'HANDLED_EXTERNALLY',
  MANUAL_REVIEW_ACCEPT = 'MANUAL_REVIEW_ACCEPT',
  MANUAL_REVIEW_REJECT = 'MANUAL_REVIEW_REJECT',
  NOTIFICATION_OF_CHARGEBACK = 'NOTIFICATION_OF_CHARGEBACK',
  NOTIFICATION_OF_FRAUD = 'NOTIFICATION_OF_FRAUD',
  OFFER_CLOSED = 'OFFER_CLOSED',
  ORDER_CLOSED = 'ORDER_CLOSED',
  ORDER_OPENED = 'ORDER_OPENED',
  PAIDOUT_REVERSED = 'PAIDOUT_REVERSED',
  PARTIAL_REFUND = 'PARTIAL_REFUND',
  PAY_BY_LINK_CANCELLATION = 'PAY_BY_LINK_CANCELLATION',
  PAYOUT_DECLINE = 'PAYOUT_DECLINE',
  PAYOUT_EXPIRE = 'PAYOUT_EXPIRE',
  PAYOUT_THIRDPARTY = 'PAYOUT_THIRDPARTY',
  PENDING_CAPTURE = 'PENDING_CAPTURE',
  POSTPONED_REFUND = 'POSTPONED_REFUND',
  PREARBITRATION_LOST = 'PREARBITRATION_LOST',
  PREARBITRATION_WON = 'PREARBITRATION_WON',
  RECURRING_CONTRACT = 'RECURRING_CONTRACT',
  REFUND = 'REFUND',
  REFUND_FAILED = 'REFUND_FAILED',
  REFUND_WITH_DATA = 'REFUND_WITH_DATA',
  REFUNDED_REVERSED = 'REFUNDED_REVERSED',
  REPORT_AVAILABLE = 'REPORT_AVAILABLE',
  REQUEST_FOR_INFORMATION = 'REQUEST_FOR_INFORMATION',
  SECOND_CHARGEBACK = 'SECOND_CHARGEBACK',
  TECHNICAL_CANCEL = 'TECHNICAL_CANCEL',
  TERMINAL_CANCEL = 'TERMINAL_CANCEL',
  TERMINAL_COMMUNICATION_FAILED = 'TERMINAL_COMMUNICATION_FAILED',
  TERMINAL_FAILED = 'TERMINAL_FAILED',
  TERMINAL_PRE_AUTH_PENDING = 'TERMINAL_PRE_AUTH_PENDING',
  THREEDS_FAILED = 'THREEDS_FAILED',
  THREEDS_PENDING = 'THREEDS_PENDING',
  VOID_PENDING_REFUND = 'VOID_PENDING_REFUND',
}

export enum PaymentHistoryStatus {
  Expired = 'Expired',
  Failed = 'Failed',
  FullRefund = 'FullRefund',
  PartialRefund = 'PartialRefund',
  Pending = 'Pending',
  RefundFailed = 'RefundFailed',
  RefundPending = 'RefundPending',
  Success = 'Success',
}

export enum PaymentItemType {
  Credit = 'CREDIT',
  Invoice = 'INVOICE',
}

export enum PaymentMethodType {
  ACH = 'ACH',
  CREDIT_CARD = 'CREDIT_CARD',
  DEBIT_CARD = 'DEBIT_CARD',
  KLARNA = 'KLARNA',
  KLARNA_ACCOUNT = 'KLARNA_ACCOUNT',
  PAD = 'PAD',
  PAYTO = 'PAYTO',
  PLAID_ACH = 'PLAID_ACH',
  TAB = 'TAB',
}

export enum PaymentMethod {
  ACH = 'ACH',
  AMEX = 'AMEX',
  DISCOVER = 'DISCOVER',
  MC = 'MC',
  PAD = 'PAD',
  PAYTO = 'PAYTO',
  PLAID_ACH = 'PLAID_ACH',
  TAB = 'TAB',
  UNKNOWN = 'UNKNOWN',
  VISA = 'VISA',
}

export enum PaymentsStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  KycVerificationPending = 'KYC_VERIFICATION_PENDING',
  KycVerificationRequired = 'KYC_VERIFICATION_REQUIRED',
}

export enum PoNumberDisplay {
  Hide = 'HIDE',
  Optional = 'OPTIONAL',
  Required = 'REQUIRED',
}

export enum PriceTrendsTimePeriod {
  L7 = 'L7',
  L30 = 'L30',
  L90 = 'L90',
  L365 = 'L365',
}

export enum PriceTypes {
  MSRP = 'MSRP',
  SRP = 'SRP',
}

export enum SampleRequestStatus {
  APPROVED = 'APPROVED',
  FINAL_REJECTED = 'FINAL_REJECTED',
  INITIAL_REJECTED = 'INITIAL_REJECTED',
  REQUESTED = 'REQUESTED',
}

export enum TooltipPosition {
  Center = 'CENTER',
  Left = 'LEFT',
  Right = 'RIGHT',
}

export enum VerificationMethod {
  Call = 'CALL',
  Email = 'EMAIL',
  Punchout = 'PUNCHOUT',
  SMS = 'SMS',
}

export enum LoginMethod {
  Email = 'EMAIL',
  Phone = 'PHONE',
}

export enum OrderGuideMergeStrategy {
  DISTRIBUTOR_LOCKED = 'DISTRIBUTOR_LOCKED',
  DISTRIBUTOR_ONLY = 'DISTRIBUTOR_ONLY',
  DISTRIBUTOR_OPERATOR_PRIORITIZED_UNION = 'DISTRIBUTOR_OPERATOR_PRIORITIZED_UNION',
  OPERATOR_DISTRIBUTOR_PRIORITIZED_UNION = 'OPERATOR_DISTRIBUTOR_PRIORITIZED_UNION',
  OPERATOR_ONLY = 'OPERATOR_ONLY',
}

export enum NotificationType {
  CRM_ACTIVITY_REMINDER = 'CRM_ACTIVITY_REMINDER',
  ORDER_TRACKING_COMPLETED = 'ORDER_TRACKING_COMPLETED',
  ORDER_TRACKING_UPDATED = 'ORDER_TRACKING_UPDATED',
  SMART_ORDER_CREATED = 'SMART_ORDER_CREATED',
  SMART_ORDER_CUTOFF_REMINDER = 'SMART_ORDER_CUTOFF_REMINDER',
  SMART_ORDER_SUBMITTED = 'SMART_ORDER_SUBMITTED',
  SUBSCRIPTION_PLACEMENT_FAILED = 'SUBSCRIPTION_PLACEMENT_FAILED',
}

export enum SubstitutionAction {
  DO_NOT_REPLACE = 'DO_NOT_REPLACE',
  SUBSTITUTE = 'SUBSTITUTE',
}

export enum SalesRepOverrideMode {
  DISABLED = 'DISABLED',
  GROSS_PROFIT = 'GROSS_PROFIT',
  PRICE = 'PRICE',
}

export enum ConsumptionTaxName {
  GST = 'GST',
  HST = 'HST',
  SALES_TAX = 'Sales Tax',
}

export enum ConsumptionTaxType {
  PERCENT = 'PERCENT',
}

export enum OrderFeeName {
  DISCOUNT = 'Discount',
  SUBTOTAL = 'Subtotal',
  TAX = 'Tax',
  TIP = 'Tip',
}

export enum VariantPackGroupType {
  Category = 'CATEGORY',
}

export enum OrderSummaryInputID {
  Notes = 'notes',
  PONumber = 'po_number',
}

export type OrderInboundSource = 'APP' | 'EMAIL' | 'SMS' | 'VOICEMAIL';

export enum NewFeature {
  AUTOPAY = 'autopay',
  INSIGHTS_HUB = 'insights_hub',
}

export enum CatalogFilter {
  BADGE = 'BADGE',
  BRAND = 'BRAND',
  CHILD_NUTRITION = 'CHILD_NUTRITION',
  COUNTRY = 'COUNTRY',
  FREE_FROM = 'FREE_FROM',
  KOSHER = 'KOSHER',
  PACK_SIZE = 'PACK_SIZE',
  SORT_ORDER = 'SORT_ORDER',
  SUBCATEGORY = 'SUBCATEGORY',
}

export enum SmartOrderProcessingStatus {
  ERROR = 'ERROR',
  FINISHED = 'FINISHED',
  PROCESSING = 'PROCESSING',
  RECEIVED = 'RECEIVED',
  REPROCESSING = 'REPROCESSING',
}

export enum SmartOrderRole {
  None = 'NONE',
  Submitter = 'SUBMITTER',
  Viewer = 'VIEWER',
}

export enum SmartOrderStatus {
  MEMORIZED = 'MEMORIZED',
  NO_RESULTS = 'NO_RESULTS',
  NOT_VERIFIED = 'NOT_VERIFIED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  SUBMITTED = 'SUBMITTED',
  UNKNOWN_CONTACT = 'UNKNOWN_CONTACT',
}

export enum VariantPackAvailabilityStatus {
  DISCONTINUED = 'DISCONTINUED',
  LOW_STOCK = 'LOW_STOCK',
  OUT_OF_STOCK = 'OUT_OF_STOCK',
  SPECIAL_ORDER = 'SPECIAL_ORDER',
}

export enum OrderableItemLabelType {
  Availability = 'availability',
  Discount = 'discount',
  Promotion = 'promotion',
}

export enum OrderHistoryScope {
  Past = 'PAST',
  Upcoming = 'UPCOMING',
}

export enum SmartOrderSearchTermStatus {
  ACTIVE = 'ACTIVE',
  DRAFT = 'DRAFT',
  NO_REUSE = 'NO_REUSE',
}

export enum LowestPerformingCustomersCardMode {
  AVG_GP_PERCENTAGE = 'AVG_GP_PERCENTAGE',
  UNITS_SOLD = 'UNITS_SOLD',
}

export enum OrderTrackingStatus {
  NORMAL = 'NORMAL',
  SKIPPED = 'SKIPPED',
}

export enum TrackableComponent {
  ANALYTICS_ACTION_SHEET = 'AnalyticsActionSheet',
  ITEM_DETAILS = 'ItemDetails',
  OBI_ITEMS_OF_INTEREST = 'ObiItemsOfInterest',
}

export enum SalesRepPortionType {
  TOTAL = 'TOTAL',
  UNIT = 'UNIT',
}

// intentionally lowercase since these actions are part of the URLs, ie
// abc.com/sales-portal/order-entry/{supplier-uuid}/{restaurant-uuid}/checkout
export enum SalesPortalOrderEntryAction {
  CHECKOUT = 'checkout',
}

/** Identifies which tab body is currently selected in the item detail panel. */
export enum ItemDetailTabKey {
  Details = 'details',
  General = 'general',
}

export enum NoteType {
  Memo = 'MEMO',
  Request = 'REQUEST',
}
